import React from 'react';

interface WheatDecorationProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const WheatDecoration: React.FC<WheatDecorationProps> = ({ 
  className = '', 
  size = 'md' 
}) => {
  const sizeClass = size === 'sm' ? 'small' : size === 'lg' ? 'large' : '';
  
  return (
    <svg 
      className={`wheat-decoration ${sizeClass} ${className}`}
      viewBox="0 0 24 24" 
      fill="currentColor"
    >
      <path d="M12 2L10.5 3.5L12 5L13.5 3.5L12 2ZM12 6L10.5 7.5L12 9L13.5 7.5L12 6ZM12 10L10.5 11.5L12 13L13.5 11.5L12 10ZM12 14L10.5 15.5L12 17L13.5 15.5L12 14ZM12 18L11 19V22H13V19L12 18ZM8 4L6.5 5.5L8 7L9.5 5.5L8 4ZM8 8L6.5 9.5L8 11L9.5 9.5L8 8ZM8 12L6.5 13.5L8 15L9.5 13.5L8 12ZM16 4L14.5 5.5L16 7L17.5 5.5L16 4ZM16 8L14.5 9.5L16 11L17.5 9.5L16 8ZM16 12L14.5 13.5L16 15L17.5 13.5L16 12Z"/>
    </svg>
  );
};

export const WheatBorder: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <div className={`wheat-border ${className}`}>
      <WheatDecoration size="sm" />
      <div className="line"></div>
      <WheatDecoration />
      <div className="line"></div>
      <WheatDecoration size="sm" />
    </div>
  );
};
